import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NgxEditorServiceConfig {
  public locals = {};
  public icons = {};
}
